<template>
  <div class="t-lazyimg" :class="classesParsed">
    <NuxtImg
      :loading="loading"
      class="t-lazyimg__img"
      format="webp"
      :provider="provider"
      :class="classesImg"
      :alt="
        alt
          ? $t('a11y.image-alt', {
              alt,
            })
          : ''
      "
      :src="srcParsed"
      placeholder
      :sizes="sizesParsed"
      :fetchpriority="priority"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { parseProtocol } from '~/utils/parseProtocol'
import type { TLazyimg_Props } from './constants/types'

const props = withDefaults(defineProps<TLazyimg_Props>(), {
  classesImg: 'object-cover absolute inset-0 h-full w-full',
  priority: 'auto',
  loading: 'lazy',
})

const classesParsed = computed(() => {
  if (props.classes !== undefined && props.classes.trim() !== '') {
    return props.classes + ' relative '
  } else {
    return 'absolute inset-0 h-full w-full'
  }
})

const srcParsed = computed(() => {
  return parseProtocol(props.sources.url)
})

const sizesParsed = computed(() => {
  if (props.provider !== undefined && props.provider.trim() !== '') {
    if (props.provider === 'directProvider') {
      return '100w'
    }
    return ''
  } else {
    return 'xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw 2xl:100vw'
  }
})
</script>

<style lang="postcss">
@import './t-lazyimg.css';
</style>
